module.exports = __webpack_public_path__ + "static/07-54c3ebc73cebadf46ab04c883362e734.jpg";